import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { PasswordValidators } from 'src/app/shared/validators/password.validators';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';
import { MiscHlp } from 'src/lib/fliko/helpers/misc.helper';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss']
})
export class PasswordInputComponent implements OnInit, ControlValueAccessor {
  public readonly LENGTH = `${PasswordValidators.MIN_LENGTH}`;
  private readonly SPECIALS = '!@#$%^&*';
  public readonly ID_NOISE = MiscHlp.randomString();

  @Input() labelKey?: LocLabel | string | null = null;
  @Input() newPassword = false;
  @Input() footer = true;

  public showPassword = false;

  public _value: any;
  public _onChange: any = () => {};
  public _onTouch: any = () => {};
  public _disabled = false;

  /** some password manager may scrap 'title' attribute instead of dedicated fields */
  public title =
    `The password must contain at least ${this.LENGTH} characters, ` +
    `including uppercase and lowercase letters, a number and a special character (${this.SPECIALS}).`;
  public rules =
    `minlength: ${this.LENGTH}; required: special; allowed: [${this.SPECIALS}]; ` +
    'required: upper; required: lower; required: digit;';
  public pattern = `(?=.*[${this.SPECIALS}])(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{${this.LENGTH},}`;

  constructor(public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {}

  // prettier-ignore
  get value(): any { return this._value; }

  set value(val: any) {
    if (val !== undefined && this._value !== val) {
      this._value = val;
      this._onChange(val);
      this._onTouch(val);
    }
  }

  // FIXME: writeValue() shouldn't call onChange() https://github.com/FlikoAdmin/FlikoWeb/pull/941
  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  get tag(): 'new-password' | 'password' {
    return this.newPassword ? 'new-password' : 'password';
  }
}
